import { render, staticRenderFns } from "./ttshop_user.vue?vue&type=template&id=66b4657e&scoped=true&"
import script from "./ttshop_user.vue?vue&type=script&lang=js&"
export * from "./ttshop_user.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_user.vue?vue&type=style&index=0&id=66b4657e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4657e",
  null
  
)

export default component.exports